export const TYPE_ACCOUNT = {
  admin: 'admin',
  user: 'user',
  advisor: 'advisor'
}

export const NAME_TYPE_ACCOUNT = {
  admin: 'Administrador',
  user: 'Normal',
  advisor: 'Asesor'
} as const

export const CATALOG_TYPE_ACCOUNT = [
  { value: TYPE_ACCOUNT.admin, label: NAME_TYPE_ACCOUNT.admin },
  { value: TYPE_ACCOUNT.user, label: NAME_TYPE_ACCOUNT.user },
  { value: TYPE_ACCOUNT.advisor, label: NAME_TYPE_ACCOUNT.advisor }
]
